import { z } from 'zod'

export const GetPotentialMlpsVariablesSchema = z.object({
    lower_timestamp_threshold: z.string()
})

export type GetPotentialMlpsVariables = z.infer<typeof GetPotentialMlpsVariablesSchema>

export const PushCheckedMlpsVariablesSchema = z.object({
    checked_mlps: z.unknown()
})

export type PushCheckedMlpsVariables = z.infer<typeof PushCheckedMlpsVariablesSchema>

export const GetPotentialMlpsQuerySchema = z.object({
    potential_mlps: z.any(),
    latest_timestamp: z.string().nullish()
})

export type GetPotentialMlpsQuery = z.infer<typeof GetPotentialMlpsQuerySchema>

export const PushCheckedMlpsMutationSchema = z.object({
    message: z.string()
})

export type PushCheckedMlpsMutation = z.infer<typeof PushCheckedMlpsMutationSchema>
